import { useClearSafeStorage } from '~/composables/useClearSafeStorage'

export default defineNuxtPlugin(() => {
  if (!process.client) return

  const router = useRouter()

  const checkQrExpiry = () => {
    const currentName = router.currentRoute.value.name?.toString().split('___')[0] || ''
    const landingRoutes = ['index', 'privacy-policy', 'terms-of-use']

    if (landingRoutes.includes(currentName)) {
      return
    }

    const qrScanTime = localStorage.getItem('qrScanTime')
    if (!qrScanTime) return

    const elapsed = Date.now() - parseInt(qrScanTime, 10)
    const threeHours = 3 * 60 * 60 * 1000 // 3 hours in ms

    if (elapsed > threeHours) {
      if (router.currentRoute.value.path !== '/expired') {
        router.push('/expired')
      }

      router.afterEach((to) => {
        if (to.path === '/expired') {
          console.log('✅ Redirected to /expired, clearing storage now...')
          useClearSafeStorage()
        }
      })
    }
  }

  checkQrExpiry()

  let interval = setInterval(checkQrExpiry, 60 * 1000)

  window.addEventListener('beforeunload', () => clearInterval(interval))

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) clearInterval(interval)
    else interval = setInterval(checkQrExpiry, 60 * 1000)
  })
})
